import { render } from "./SkeletonCustom.vue?vue&type=template&id=23a49fae"
const script = {}

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__